export enum KeyboardEnum {
  KEY_BACKSPACE = 'Backspace',
  KEY_DELETE = 'Delete',
  KEY_F2 = 'F2', //Excel cell activation key
  KEY_ENTER = 'Enter',
  KEY_TAB = 'Tab',
  KEY_ARROW_LEFT = 'ArrowLeft',
  KEY_ARROW_RIGHT = 'ArrowRight',
}
